import React from 'react'

const Diabetes = ({ exams }) => {
    let hemoglucotestMessage = '';
    let glycemiaMessage = '';
    let hemoglobinaMessage = '';

    const getMessage = (type, result) => {
        if (result === null || result === undefined) return '';

        const value = typeof result === 'number' ? result : Number(result);
        if (Number.isNaN(value)) return '';

        if (type === 'Hemoglucotest' || type === 'Glicemia en Sangre 1') {
            return value < 110 ? 'En rango' : 'Fuera de rango';
        }
        if (type === 'Hemoglobina Glicosilada 1') {
            return value < 5.7 ? 'En rango' : 'Fuera de rango';
        }
        return '';
    };

    return (
        <>
            {exams.map((item, pos) => {
                if (item.healthBenefitName === 'Hemoglucotest') {
                    hemoglucotestMessage = getMessage(
                        'Hemoglucotest',
                        item?.currentLastResult?.glicemia ?? null
                    );
                }
                if (item.healthBenefitName === 'Glicemia en Sangre 1') {
                    glycemiaMessage = getMessage(
                        'Glicemia en Sangre 1',
                        item?.currentLastResult?.glicemia ?? null
                    );
                }
                if (item.healthBenefitName === 'Hemoglobina Glicosilada 1') {
                    hemoglobinaMessage = getMessage(
                        'Hemoglobina Glicosilada 1',
                        item?.currentLastResult?.HbA1C ?? null
                    );
                }

                return (
                    <React.Fragment key={pos}>
                        {item.healthBenefitName === 'Hemoglucotest' ? (
                            <tr>
                                <td>Hemoglucotest</td>
                                <td>
                                    {item.hasPreviousYear ? item?.previousLastResult?.glicemia ?? '' : ''}
                                </td>
                                <td>
                                    {item.hasCurrentYear ? item?.currentLastResult?.glicemia ?? '' : ''}
                                </td>
                                <td>Menor a 110 mg/dl</td>
                                <td>{hemoglucotestMessage}</td>
                            </tr>
                        ) : null}

                        {item.healthBenefitName === 'Glicemia en Sangre 1' ? (
                            <tr>
                                <td>Glicemia en Sangre</td>
                                <td>
                                    {item.hasPreviousYear ? item?.previousLastResult?.glicemia ?? '' : ''}
                                </td>
                                <td>
                                    {item.hasCurrentYear ? item?.currentLastResult?.glicemia ?? '' : ''}
                                </td>
                                <td>Menor a 110 mg/dl</td>
                                <td>{glycemiaMessage}</td>
                            </tr>
                        ) : null}

                        {item.healthBenefitName === 'Hemoglobina Glicosilada 1' ? (
                            <tr>
                                <td>Hemoglobina Glicosilada</td>
                                <td>
                                    {item.hasPreviousYear ? item?.previousLastResult?.HbA1C ?? '' : ''}
                                </td>
                                <td>
                                    {item.hasCurrentYear ? item?.currentLastResult?.HbA1C ?? '' : ''}
                                </td>
                                <td>Menor a 5.7 %</td>
                                <td>{hemoglobinaMessage}</td>
                            </tr>
                        ) : null}
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default Diabetes;
